<template>
    <div v-if="campaign.deliveryJson != null && isLoaded" class="delivery-content">
        <div class="address-delivery">
            <div class="address-delivery-title">
                <div>{{lbl.detail.delivery_to}}</div>
                <div class="color-orange">{{lbl.detail.edit_address}}</div>
            </div>
            <div class="address-deliver-content">{{ address.address }}</div>
        </div>
        <div class="delivery-type">
            <div>{{delivery[0].name}}</div>
            <div class="delivery-price">{{delivery[0].price == 0 ? lbl.detail.free : delivery[0].price}}</div>
        </div>
    </div>
</template>

<script>
import Account from "@/helper/AccountHelper.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";
export default {
    name: "AddressDelivery",
    mixins: [ ErrorApiMixin ],
    props: {
        lbl: Object,
        campaign: Object
    },
    data: function() {
        return {
            addressList: [],
            address: null,
            isLoaded: false,
            delivery: [],
        };
    },
    mounted: function() {
        this.delivery = JSON.parse(this.campaign.deliveryJson)
        if (this.delivery) {
            this.getAddressList();
        }
    },
    methods: {
        getAddressList: function() {
            var token = Account.getToken();
            BzbsAddressList.apiGetAddressList(token).subscribe((addressList) => {
                this.addressList = addressList;
                for ( var i of this.addressList) {
                    if (i.isDefault) {
                        this.address = i;
                    }
                }
                this.isLoaded = true;
            }, (err) => {
                this.errorApi(err);
            });
        },
    }
}
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";

.delivery-content {
    margin: 15px 0 0;
    padding: 16px;
    background-color: $a-gray-f6f6f6;
    border-radius: 8px;
    font-size: $px14;
    .address-delivery {
        padding-bottom: 8px;
        .address-delivery-title {
            display: flex;
            justify-content: space-between;
            color: $a-gray-999999;
        }
        .address-deliver-content {
            color: $a-black-333333;
            padding-top: 14px;
        }

        .color-orange {
            color: $a-orange-f8a51b;
        }
    }
    .delivery-type {
        border-top: 1px solid $a-gray-cdcdcd;
        padding-top: 8px;
        display: flex;
        justify-content: space-between;
        color: $a-black-333333;

        .delivery-price {
            color: $a-gray-cdcdcd;
        }
        .delivery-price {
            color: $a-orange-f8a51b;
        }
    }
}
</style>
